// Finding the control a tour step points at.
//
// A step names one or more `data-guide` keys; the first key with an element
// that is actually ON SCREEN wins. "On screen" is getClientRects().length, not
// querySelector: a display:none element (a sidebar hidden on a phone, the
// Song panel column below 1200px) still matches a selector, and ringing an
// element with no box would draw a ring around nothing.

export const targetKeys = (step) => [].concat((step && step.target) || []);

const isShown = (el) => {
	if (!el || !el.getClientRects || el.getClientRects().length === 0) return false;
	const r = el.getBoundingClientRect();
	return r.width > 0 && r.height > 0;
};

export function findGuideTarget(step, root = typeof document !== 'undefined' ? document : null) {
	if (!root) return null;
	for (const key of targetKeys(step)) {
		const found = [...root.querySelectorAll(`[data-guide="${key}"]`)].find(isShown);
		if (found) return found;
	}
	return null;
}

/**
 * Where the tour card goes: away from the target, so it never covers the
 * control it is pointing at. Top when the target sits in the lower half of
 * the viewport, bottom otherwise (and bottom when there is no target).
 */
export function cardPlacement(rect, viewportHeight) {
	if (!rect) return 'bottom';
	const middle = rect.top + rect.height / 2;
	return middle > viewportHeight * 0.5 ? 'top' : 'bottom';
}
